import { useMemo } from "react";
import { aggregateCampaignStatisticsTotals } from "../utils/aggregateCampaignStatisticsTotals";

const useGlobalReportDerivedMetrics = ({
  campaigns = {},
  statistics = {},
  previousPeriodStatistics = {},
  dispatch,
  hasExplicitRange = false,
}) => {
  const totals = useMemo(
    () =>
      aggregateCampaignStatisticsTotals({
        campaigns,
        statistics,
        dispatch,
      }),
    [campaigns, dispatch, statistics]
  );

  const totalsLastPeriod = useMemo(() => {
    const previousCampaigns = previousPeriodStatistics?.campaigns || {};

    if (!hasExplicitRange || !Object.keys(previousCampaigns).length) {
      return null;
    }

    return aggregateCampaignStatisticsTotals({
      campaigns,
      statistics: previousPeriodStatistics,
      dispatch,
    });
  }, [campaigns, dispatch, hasExplicitRange, previousPeriodStatistics]);

  return {
    totals,
    totalsLastPeriod,
  };
};

export default useGlobalReportDerivedMetrics;
